import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { tokens } from '../../../design-system/tokens';

const imgLogo = "/assets/images/logo.svg";

const FooterContainer = styled.footer`
  background-color: ${tokens.colors.neutral[50]};
  padding: ${tokens.spacing[8]} ${tokens.spacing[5]};
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing[5]};
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${tokens.colors.neutral[200]};

  @media (max-width: ${tokens.breakpoints.sm}) {
    padding: ${tokens.spacing[6]} ${tokens.spacing[4]};
  }
`;

const Logo = styled.div`
  width: 102px;
  height: 20px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    aspect-ratio: 102 / 20 !important;
    object-fit: contain;
  }
`;

const BusinessInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing[2]};
  align-items: center;
  text-align: center;
`;

const InfoRow = styled.p`
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${tokens.typography.fontSize.xs};
  font-weight: ${tokens.typography.fontWeight.regular};
  color: ${tokens.colors.neutral[600]};
  margin: 0;
  line-height: 1.5;
  word-break: keep-all;
  overflow-wrap: break-word;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: ${tokens.spacing[4]};
  align-items: center;
  margin: ${tokens.spacing[2]} 0;

  a {
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: ${tokens.typography.fontSize.sm};
    font-weight: ${tokens.typography.fontWeight.medium};
    color: ${tokens.colors.neutral[700]};
    text-decoration: none;
    transition: color ${tokens.animation.duration.fast} ${tokens.animation.easing.ease};

    &:hover {
      color: ${tokens.colors.primary[500]};
    }
  }

  span {
    color: ${tokens.colors.neutral[300]};
  }
`;

const Copyright = styled.p`
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: ${tokens.typography.fontSize.xs};
  font-weight: ${tokens.typography.fontWeight.regular};
  color: ${tokens.colors.neutral[500]};
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  letter-spacing: 0.5px;
`;


export const Footer: React.FC<{ 'data-name'?: string; 'data-node-id'?: string }> = (props) => {
  return (
    <FooterContainer {...props}>
      <Logo data-name="logo" data-node-id="106:73">
        <img src={imgLogo} alt="LuckyOn Logo" />
      </Logo>

      <BusinessInfo>
        <InfoRow>
          카인드바이럴 | 사업자등록번호: 694-73-00134
        </InfoRow>
        <InfoRow>
          통신판매업신고: 2017-수원팔달-0406
        </InfoRow>
        <InfoRow>
          경기도 수원시 팔달구 경수대로 466번길 58, 410호
        </InfoRow>
        <InfoRow>
          고객센터: 1661-2847 | 이메일: help@kindviral.com
        </InfoRow>
      </BusinessInfo>

      <LegalLinks>
        <Link to="/terms">이용약관</Link>
        <span>|</span>
        <Link to="/privacy">개인정보처리방침</Link>
      </LegalLinks>

      <Copyright data-node-id="99:243">© 2025 KINDVIRAL. All Rights Reserved.</Copyright>
    </FooterContainer>
  );
};